import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { getWhatsAppLink, siteConfig } from "@/content/siteData";

export const WhatsAppFloat = () => {
  const location = useLocation();
  const whatsappLink = getWhatsAppLink();
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    const footerElement = document.querySelector('[data-testid="site-footer"]');

    if (!footerElement) {
      setIsFooterVisible(false);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterVisible(entry.isIntersecting);
      },
      { threshold: 0.15 }
    );

    observer.observe(footerElement);

    return () => observer.disconnect();
  }, [location.pathname]);

  const shouldHideFloat = isFooterVisible || location.pathname === "/contact";

  return (
    <a
      href={whatsappLink}
      className={`fixed bottom-4 right-4 z-50 hidden items-center gap-2 rounded-full bg-primary px-4 py-2.5 text-sm font-semibold text-white shadow-lg transition-[opacity,transform,background-color] duration-300 hover:scale-[1.02] hover:bg-primary/90 md:bottom-5 md:right-5 md:inline-flex ${
        shouldHideFloat ? "pointer-events-none translate-y-4 opacity-0" : "translate-y-0 opacity-100"
      }`}
      data-testid="floating-whatsapp-button"
      aria-hidden={shouldHideFloat}
      tabIndex={shouldHideFloat ? -1 : 0}
    >
      <MessageCircle className="h-4 w-4" />
      <span className="hidden lg:inline" data-testid="floating-whatsapp-button-label">
        {siteConfig.whatsappCtaLabel}
      </span>
    </a>
  );
};